import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element'
import './theme/element-variables.scss'

import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)

import ImcEle from 'imc-ele'
import 'imc-ele/dist/imc-ele.css'

let isQf = window.location.hostname.indexOf('aitongqian') !== -1
if (isQf) {
    let link = document.querySelector('link[rel="icon"]') || document.createElement('link')
    link && (link.href = 'https://image-pub.guazistatic.com/qnbdp1066x7da39fb3fa614bf3b67a9b20a0032ea11741071043.ico')
}

Vue.use(ImcEle)

Vue.prototype.$isQf = isQf
Vue.config.productionTip = false
new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
